import Notifier from 'common/helpers/Notifier';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import { coreApi } from 'src/api/config';

const onError = (error) => {
  Notifier.handleErrors(error);
  return error;
};

const deleteRecordLanguage = async (recordLanguageId) => {
  try {
    const response = await coreApi.deleteRecord('record_language', recordLanguageId);
    if (!response || !isHttpSuccess(response.status)) {
      return onError(response);
    }
    return response;
  } catch (error) {
    return onError(error);
  }
};

export default deleteRecordLanguage;
